/** Client-side garage cache keys (keep in sync with {@link GarageContext}). */
export const GARAGE_STORAGE_KEY_CARS = "petromin-garage-cars";
export const GARAGE_STORAGE_KEY_SERVICES = "petromin-garage-services";

export function clearGarageLocalStorage(): void {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(GARAGE_STORAGE_KEY_CARS);
    localStorage.removeItem(GARAGE_STORAGE_KEY_SERVICES);
  } catch {
    /* ignore */
  }
}
